import {Dce, DceComponent, DceHTMLElement} from "dce-engine";

interface ConfirmButtonProps {
    modal: string;
}

@Dce("AlertButton")
export default class AlertButton extends DceComponent<ConfirmButtonProps> {


    constructor(elem: DceHTMLElement, props: ConfirmButtonProps) {
        super(elem, props);

        elem.addEventListener('click', e => {
            alert("test asd");
        })

    }

}
